import 'toastr/toastr.scss';

import toaster from 'toastr';

class ToastClass {

    static TOP_RIGHT = 'toast-top-right';
    static TOP_LEFT = 'toast-top-left';
    static BOTTOM_RIGHT = 'toast-bottom-right';
    static BOTTOM_BOTTOM_LEFT = 'toast-bottom-left';
    static BOTTOM_TOP_FULL = 'toast-top-full-width';
    static BOTTOM_BOTTOM_FULL = 'toast-bottom-full-width';
    static BOTTOM_TOP_CENTER = 'toast-top-center';
    static BOTTOM_CENTER = 'toast-bottom-center';

    info(message, title, options) {
        toaster.info(message, title, options);
    }

    error(message, title, options = {}) {
        toaster.error(message, title, {
            ...options,
            ...{
                positionClass: 'toast-top-right error-gosociali'
            }
        });
    }

    success(message, title, options) {
        toaster.success(message, title, options);
    }

    warning(message, title, options) {
        toaster.warning(message, title, options);
    }

    clear() {
        toaster.clear();
    }

    remove() {
        toaster.remove();
    }
}

export const toast = new ToastClass();

export default {
    install: (app, options) => {
        if (options) {
            toaster.options = {...toaster.options, ...options};
        }

        app.config.globalProperties.toastClass = ToastClass;
        app.config.globalProperties.toast = new ToastClass();
    }
}
